export default __webpack_public_path__ + "static/media/icon_animate_timer.c942703d.svg";